/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreModelKey } from '../key/core-model.key';
import { ApplicationError } from '../model/application-error.model';
import { ValidationError } from '../model/validation-error.model';
import { MessageFactory, MessageFactoryProvider } from '../provider/message-factory.provider';
import { TextService } from '../service/text.service';

export class ObjectValidationErrorMessageFactory implements MessageFactory {

  constructor(private textService: TextService) { }

  getMessage(error: ApplicationError): string {
    const textKey = error.key;
    const errorArguments: { [key: string]: any } = error.arguments;
    const type = errorArguments.scope ? `#(${errorArguments.scope}/type)` : undefined;
    const errors: string[] = this.getErrorMessages(errorArguments.errors, errorArguments.scope);
    const textArgs = Object.assign({}, error.arguments, { type, errors });
    return this.textService.getText(textKey, textArgs);
  }

  getErrorMessages(errors: { [key: string]: ValidationError[] }, scope: string): string[] {
    const validationErrorMessageFactory = MessageFactoryProvider.resolveMessageFactory(CoreModelKey.VALIDATION_ERROR);
    return Object.keys(errors).map((key: string) => {
      const field = scope ? `${scope}/field/${key}` : key;
      const validationErrorMessages: string[] = errors[key].map((validationError: ValidationError) => {
        return validationErrorMessageFactory
          ? validationErrorMessageFactory.getMessage(validationError)
          : JSON.stringify(validationError);
      });
      return `#(${field}): ${validationErrorMessages.join('; ')}`;
    });
  }

}
